export default "__VITE_ASSET__BWCjISnK__"